/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactdate1Inputs */

const de__field_contactdate1 = /** @type {(inputs: _Field_Contactdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktdatum`)
};

/**

* @param {_Field_Contactdate1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactdate1 = /** @type {((inputs?: _Field_Contactdate1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactdate1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactdate1(inputs)
});
export { _field_contactdate1 as "_field_contactDate" }